module.exports = __webpack_public_path__ + "static/404-3c26e83e53532d786c8df4c82137abfb.svg";